import api from 'common/api';

export const getPreAlertAPI = (params: any) => api.get('/special-search-detail-export/detail', params);
export const getPreAlertEncryptAPI = (params: any) => api.get('/special-search-detail-export/detail-encrypt', params);
